import React from 'react';
import PropTypes from 'prop-types';

export default function CloseIcon({ color, width, height }) {
  return (
    <svg
      id="close-icon"
      x="0px"
      y="0px"
      viewBox="0 0 9.29 9.29"
      width={width}
      height={height}
    >
      <path fill={color} d="M5.21,4.64l4-4a.4.4,0,0,0,0-.56.4.4,0,0,0-.57,0l-4,4-4-4a.39.39,0,0,0-.56,0,.39.39,0,0,0,0,.56l4,4-4,4a.4.4,0,0,0,0,.57.39.39,0,0,0,.28.12.39.39,0,0,0,.28-.12l4-4,4,4a.4.4,0,0,0,.29.12.39.39,0,0,0,.28-.12.42.42,0,0,0,0-.57Z"/></svg>
  );
}


CloseIcon.defaultProps = {
  color: '#fff',
  width: '24',
  height: '24'
}

CloseIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
